export const ROOT_FOOT_SIZE = 16

interface Breakpoints {
  sm: number
  md: number
  lg: number
  xl: number
  "2xl": number
  "3xl": number
  split?: number
}

// should match BREAKPOINTS set in globals.css
export const BREAKPOINTS: Breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
  "3xl": 1800,
}

BREAKPOINTS.split = BREAKPOINTS.lg

export const MEDIA_QUERIES = {
  xsMax: `(max-width: ${BREAKPOINTS.sm - 1}px)`,
  sm: `(min-width: ${BREAKPOINTS.sm}px)`,
  smMax: `(max-width: ${BREAKPOINTS.md - 1}px)`,
  md: `(min-width: ${BREAKPOINTS.md}px)`,
  mdMax: `(max-width: ${BREAKPOINTS.lg - 1}px)`,
  lg: `(min-width: ${BREAKPOINTS.lg}px)`,
  lgMax: `(max-width: ${BREAKPOINTS.xl - 1}px)`,
  xl: `(min-width: ${BREAKPOINTS.xl}px)`,
  xlMax: `(max-width: ${BREAKPOINTS["2xl"] - 1}px)`,
  "2xl": `(min-width: ${BREAKPOINTS["2xl"]}px)`,
  "2xlMax": `(max-width: ${BREAKPOINTS["3xl"] - 1}px)`,
  "3xl": `(min-width: ${BREAKPOINTS["3xl"]}px)`,
  split: `(min-width: ${BREAKPOINTS.lg}px)`,
  // Not width queries, but the same job: a query string named once so TS and
  // CSS cannot drift. canHover matches the `can-hover` variant in globals.css.
  canHover: "(hover: hover) and (pointer: fine)",
  reducedMotion: "(prefers-reduced-motion: reduce)",
}

// should match CONTAINER_SIZES set in globals.css
export const CONTAINER_SIZES = {
  "3xs": 256,
  "2xs": 288,
  xs: 320,
  sm: 384,
  md: 448,
  lg: 512,
  xl: 576,
  "2xl": 672,
  "3xl": 768,
  "4xl": 896,
  "5xl": 1024,
  "6xl": 1152,
  "7xl": 1280,
}

// this should match `--header-height` set in globals.css
export const HEADER_HEIGHT = 48

export const TRANSITION_DURATION_DEFAULT = 150
export const DRAWER_ANIMATION_DURATION = 500
export const DRAWER_ANIMATION_EASE = [0.32, 0.72, 0, 1] as const
export const DIALOG_ANIMATION_DURATION = 300

export const KEYS = {
  END: "End",
  HOME: "Home",
  LEFT: "ArrowLeft",
  UP: "ArrowUp",
  RIGHT: "ArrowRight",
  DOWN: "ArrowDown",
  ENTER: "Enter",
  SPACE: " ",
  ESC: "Escape",
  TAB: "Tab",
  BACKSPACE: "Backspace",
  DELETE: "Delete",
}

export const TYPED_SENTENCE_VARIANTS = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      delayChildren: 0.5,
      staggerChildren: 0.015,
    },
  },
  exit: {
    opacity: 0,
    y: 20,
  },
}

export const TYPED_LETTER_VARIANTS = {
  visible: { display: "inline" },
  hidden: { display: "none" },
  exit: { display: "inline" },
}

// TODO: move to an env var
export const GOOGLE_MAP_ID = "a954bab6eafe4edb"

// Kept to a minimum for more cache hits
export const IMAGE_SIZES = {
  sm: 360,
  md: 720,
  lg: 960,
  xl: 1200,
  "2xl": 1920,
}

export const DRAWER_CLOSED_HEIGHT = 75

export const TOAST_WITH_ACTION_DURATION = 8000
